import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp12};
  border-bottom: 1px solid ${props => props.theme.colors.grey.tone100};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`
